export function slugify(value: string): string {
  return value
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function toEntitySlug(label: string, id: string): string {
  const normalizedLabel = slugify(label) || 'item';
  return `${normalizedLabel}--${encodeURIComponent(id)}`;
}

export function idFromEntitySlug(slugParam: string | undefined): string | null {
  if (!slugParam) {
    return null;
  }

  const separatorIndex = slugParam.lastIndexOf('--');
  if (separatorIndex === -1) {
    return null;
  }

  const encodedId = slugParam.slice(separatorIndex + 2);
  if (!encodedId) {
    return null;
  }

  try {
    return decodeURIComponent(encodedId);
  } catch {
    return null;
  }
}
